import { Paper, Stack, Typography } from '@mui/material';
import DateRangePicker from '../../../components/date-range-picker';

export const CallTrendAnalyticsDateRangeFilter = ({
    fromDate,
    toDate,
    onFromChange,
    onToChange,
    disabled,
}) => {
    return (
        <Paper elevation={1} sx={{ p: 2, border: '1px solid #d0d0d0', mb: 3 }}>
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
            >
                <Stack spacing={0.5}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        Call Trend Analytics Date Filter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        All call trend analytics charts use this date range.
                    </Typography>
                </Stack>

                <DateRangePicker
                    fromDate={fromDate}
                    toDate={toDate}
                    onFromChange={onFromChange}
                    onToChange={onToChange}
                    disabled={disabled}
                    fromLabel="From"
                    toLabel="To"
                />
            </Stack>
        </Paper>
    );
};

export default CallTrendAnalyticsDateRangeFilter;